import React, { useEffect, useState } from 'react';

import { ReactComponent as ModelIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import TabToggle from '../../shared-components/tab-toggle/TabToggle';

import Global from './components/Global';
import Local from './components/Local';

/**
 * Model management page — connects Local and Global model tabs.
 * @returns {React.JSX.Element} ModelManagement page
 */
function ModelManagement() {
  const dispatch = useAppDispatch();
  const { totalResults: localTotal } = useAppSelector((state) => state.model);
  const { totalResults: globalTotal } = useAppSelector((state) => state.globalModel);

  const [selectedTab, setSelectedTab] = useState<string>('Local');

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: 'Models',
        count: selectedTab === 'Local' ? localTotal : globalTotal,
        icon: <ModelIcon />,
      }),
    );
  }, [dispatch, localTotal, globalTotal, selectedTab]);

  return (
    <div className="model-management-wrap">
      <div className="model-management-container">
        <div className="table-content">
          <div className="tab-toggle-wrapper">
            <TabToggle
              tabs={[
                { label: 'Local', value: 'Local' },
                { label: 'Global', value: 'Global' },
              ]}
              defaultTab="Local"
              onChange={(tab) => setSelectedTab(tab)}
            />
          </div>

          {selectedTab === 'Local' ? <Local /> : <Global />}
        </div>
      </div>
    </div>
  );
}

export default ModelManagement;
